class CartDrawer extends Theme.Drawer {
  connectedCallback() {
    document.addEventListener("addtocart", (event) => {
      this.render().then(() => this.show());
    });

    document.addEventListener("cartlink:click", (event) => {
      this.show();
    });

    if (Theme.URLParams.get("cart") === "open") {
      this.show();
    }

    super.connectedCallback();
  }

  show() {
    document.dispatchEvent(new CustomEvent("cartdrawer:show"));
    this.updateCartParam(true);

    super.show();
  }

  hide() {
    super.hide();
    this.updateCartParam(false);
  }

  guard(task) {
    if (this.pending) {
      return Promise.resolve();
    }

    this.pending = true;
    this.classList.add("state--pending");
    this.setAttribute("aria-busy", "true");

    return Promise.resolve()
      .then(task)
      .finally(() => {
        this.pending = false;
        this.classList.remove("state--pending");
        this.removeAttribute("aria-busy");
      });
  }

  changeSubscription(item, element) {
    return this.guard(() => this.updateLine({
      id: item.key,
      quantity: item.quantity,
      selling_plan: element.value
    }));
  }

  changeIntoSubscription(item) {
    return this.guard(() => fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify({ items: [item] })
    })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((error) => Promise.reject(error));
      }

      return this.updateLine({ id: item.key, quantity: 0 });
    })
    .catch((error) => {
      console.error("CartDrawer: subscribe failed", error);
    }));
  }

  change(data, element) {
    return this.guard(() => this.updateLine(data, element));
  }

  updateLine(data, element) {
    const container = element ? element.closest(".spinner-container") : null;

    if (container) {
      container.classList.add("state--loading");
    }

    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(Object.assign({ sections: "cart-drawer" }, data))
    })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((error) => Promise.reject(error));
      }

      return response.json();
    })
    .then((cart) => {
      const sections = cart.sections;

      delete cart.sections;

      document.dispatchEvent(new CustomEvent("cart:change", {
        detail: cart
      }));

      const giftLinesToRemove = this.checkCartGifts(cart);

      if (giftLinesToRemove.length) {
        return this.removeCartGifts(giftLinesToRemove)
          .then(() => this.render());
      }

      return this.render(sections);
    })
    .catch((error) => {
      if (container) {
        container.classList.remove("state--loading");
      }

      console.error("CartDrawer: change failed", error);
    });
  }

  updateCartParam(isOpen) {
    const url = new URL(window.location.href);

    if (isOpen) {
      url.searchParams.set("cart", "open");
    } else {
      url.searchParams.delete("cart");
    }

    window.history.replaceState({}, "", url);
  }

  render(sections) {
    function get_new_content(markup) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(markup, "text/html");

      return doc.getElementById("cart");
    }

    const markup = sections && sections["cart-drawer"]
      ? Promise.resolve(sections["cart-drawer"])
      : fetch("/?sections=cart-drawer")
        .then((response) => response.json())
        .then((response) => response["cart-drawer"]);

    return markup
      .then((string) => {
        const current_content = document.getElementById("cart");
        const focus_was_lost = document.activeElement === document.body;
        const restore_focus = this.isOpen && (focus_was_lost || current_content.contains(document.activeElement));

        current_content.replaceWith(get_new_content(string));

        if (restore_focus) {
          this.focusPanel();
        }
      })
      .then(() => this.resetActionEvents())
      .then(() => this.logCartGifts())
      .then(() => this.initLoop());
  }

  logCartGifts() {
    const el = this.querySelector('[data-cart-gifts]');

    if (!el) {
      console.log('cart gifts: no element');
      return;
    }

    const threshold = el.dataset.threshold;
    const giftProductIds = el.dataset.giftProductIds;

    console.log('cart gifts threshold:', threshold);
    console.log('cart gifts product ids:', giftProductIds);
  }

  checkCartGifts(cart) {
    const el = this.querySelector('[data-cart-gifts]');

    if (!el) {
      console.log('checkCartGifts: no element');
      return [];
    }

    const threshold = parseInt(el.dataset.threshold, 10);

    console.log('checkCartGifts threshold:', threshold);

    let giftTotal = 0;
    const giftLinesToRemove = [];

    cart.items.forEach((item) => {
      if (item.properties && item.properties._cart_gift === 'true') {
        giftTotal += item.line_price;
        giftLinesToRemove.push({
          id: item.key,
          quantity: 0
        });
      }
    });

    const qualifyingTotal = cart.items_subtotal_price - giftTotal;

    console.log('checkCartGifts subtotal:', cart.items_subtotal_price);
    console.log('checkCartGifts giftTotal:', giftTotal);
    console.log('checkCartGifts qualifyingTotal:', qualifyingTotal);

    if (qualifyingTotal < threshold) {
      console.log('checkCartGifts: below threshold, should remove gift');
      console.log('checkCartGifts lines to remove:', giftLinesToRemove);
      return giftLinesToRemove;
    }

    console.log('checkCartGifts: still qualifies');
    return [];
  }

  removeCartGifts(lines) {
    const requests = lines.map((line) => {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(line)
      }).then((response) => response.json());
    });

    return Promise.all(requests).then((responses) => {
      console.log('removeCartGifts responses:', responses);
      return responses;
    });
  }

  initLoop() {
    if (window.LoopOnstore && window.LoopOnstore.isActive()) {
      const routeCheckoutButton = document.querySelector('a[name="button-route-3"]');
      if (routeCheckoutButton) {
        routeCheckoutButton.style.setProperty('display', 'none', 'important');
      }
      const shopifyCheckoutButton = document.querySelector('#checkout-button');
      if (shopifyCheckoutButton) {
        shopifyCheckoutButton.style.removeProperty('display');
      }
    }
  }
}

customElements.define("cart-drawer", CartDrawer);
